// extracted by mini-css-extract-plugin
export default {"button":"CarouselNavButton__button___HA15R","previous":"CarouselNavButton__previous___Nf2L4","next":"CarouselNavButton__next___UcttK"};